import React from "react";
import PropTypes from "prop-types";

import { gql } from "@apollo/client";
import { Mutation } from "@apollo/client/react/components";
import { OrderObject } from "../Queries/OrderQuery";
import orderFragments from "../Queries/graphql/orderFragments";
import orderLinesAndEvents from "../Queries/graphql/orderLinesAndEvents";
import PauseEpiSyncBtn from "./PauseEpiSyncBtn";

const PAUSE_EPI_SYNC = gql`
  mutation pauseEpiSyncForOrder($id: ID!) {
    pauseEpiSyncForOrder(id: $id) {
      order {
        ...OrderFields
        ...OrderLinesAndEventsQuery
      }
    }
  }
  ${orderFragments.query}
  ${orderLinesAndEvents.query}
`;

class PauseEpiSync extends React.Component {
  render() {
    const { order } = this.props;
    return (
      <Mutation mutation={PAUSE_EPI_SYNC}>
        {(update, { loading, error }) => (
          <PauseEpiSyncBtn order={order} update={update} />
        )}
      </Mutation>
    );
  }
}

PauseEpiSync.propTypes = {
  order: OrderObject.isRequired
};

export default PauseEpiSync;

